import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendJob, BackendMutationGenerateLongFormAssetImageArgs } from 'src/types/backend';

type FeedJob = Pick<BackendJob, 'id' | 'status'>;

const MUTATION = gql`
  mutation GenerateLongFormAssetImage(
    $longFormAssetId: ID!
    $generationTool: GenerationToolEnum!
    $newLongFormAsset: Boolean
    $instruction: Instruction
    $promptInstructionsData: JSON
    $mediaGenerationParameters: MediaGenerationParametersInput
  ) {
    generateLongFormAssetImage(
      longFormAssetId: $longFormAssetId
      generationTool: $generationTool
      newLongFormAsset: $newLongFormAsset
      instruction: $instruction
      promptInstructionsData: $promptInstructionsData
      mediaGenerationParameters: $mediaGenerationParameters
    ) {
      id
      status
    }
  }
`;

/**
 * Enqueues the generation and answers with the job running it — the image is a full round trip to
 * author-complete. The asset it lands in comes back through the job's asset groups.
 */
export const generateLongFormAssetImage = async (
  variables: BackendMutationGenerateLongFormAssetImageArgs
): Promise<FeedJob | null> => {
  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: { traceAcRequests: true },
  });
  return getSingleProp<FeedJob>(response.data) ?? null;
};
